module.exports = __webpack_public_path__ + "img/pvc_900g_b1_farbauswahl_rot_schwarz.1c57fc37.jpg";